import styled from 'styled-components'
import { db, FirebaseTimestamp } from '../firebase'
import { Layout } from '../components'
// mui
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { useState, useEffect } from 'react'


const MonthRow = props => {
    return (
        <TableRow key={5} hover role="checkbox" tabIndex={-1} selected={false}>
            <TableCell align="center">{props.month}</TableCell>
            <TableCell align="center">{props.sales}</TableCell>
            <TableCell align="center">{props.orderCount}</TableCell>
            <TableCell align="center">{props.productCount}</TableCell>
        </TableRow>
    )
}

const SalesManager = () => {

    const [orders, setOrders] = useState([])

    // 各月の売上を計算
    const calcMonthlySales = orders => {
        return orders.reduce((previousValue, currentValue)=>
            previousValue + currentValue.amount
        ,0)
    }
    // 各月の販売個数を計算
    const calcMonthlyProductCount = orders => {
        return orders.reduce((prevOrder, currentOrder)=>
            prevOrder + currentOrder.products.reduce((prevProduct,currentProduct) => 
                prevProduct + ( currentProduct.quantity ? currentProduct.quantity : 0)
            ,0)
        ,0)
    }
    

    // 年月
    useEffect(()=>{
        // 直近月のリスト取得
        const tempOrders = []
        const monthlyData = []
        const dt = new Date()
        const months = [dt.getFullYear() + '/' + ('00' + (dt.getMonth()+1)).slice(-2)]
        for (let i = 1; i < 6; i++) {
            dt.setMonth(dt.getMonth() - 1)
            months.push(dt.getFullYear() + '/' + ('00' + (dt.getMonth()+1)).slice(-2) )
        }
        
        for (const [key, month] of months.entries()) {
            // 末日処理
            const [yearPart, monthPart] = month.split('/')
            let lastDay = ''
            if (['01','03','05','07','08','10','12'].indexOf(monthPart) !== -1) {
                lastDay = '31'
            } else {
                if (monthPart === '02') {
                    lastDay = (yearPart % 4 === 0) ? '29': '28'
                } else {
                    lastDay = '30'
                }
            }
            
            // データ取得期間設定
            const endOfMonth = FirebaseTimestamp.fromDate(new Date(month + '/' + lastDay + ' 23:59:59'))
            const startOfMonth = FirebaseTimestamp.fromDate(new Date(month + '/01 00:00:00'))

            // データ取得・集計
            db.collectionGroup('orders')
                .orderBy('created_at','desc')
                .startAt(endOfMonth).endAt(startOfMonth)
                .get()
                .then(snapshots => {
                    const tempList = []
                    snapshots.forEach(snapshot => {
                        tempList.push(snapshot.data())
                    })
                    tempOrders[key] = {
                        month: month,
                        sales: calcMonthlySales(tempList),
                        orderCount: tempList.length,
                        productCount: calcMonthlyProductCount(tempList),
                    }
                    monthlyData.push(tempOrders[key])
                    setOrders([monthlyData])
                })
        }
    },[])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>売上管理</h1>
            <div className='spacer-50' />

            <Wrapper>
                <TableContainer>
                    <Table size={'medium'}>
                        <TableHead>
                            <TableRow>  
                                <TableCell key={1} align={'center'} padding={'default'}>年月</TableCell>
                                <TableCell key={3} align={'center'} padding={'default'} >売上金額</TableCell>
                                <TableCell key={4} align={'center'} padding={'default'} >注文数</TableCell>
                                <TableCell key={5} align={'center'} padding={'default'} >商品数</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {orders[0] && orders[0].map(order => (
                                <MonthRow 
                                    key={order.month}
                                    month={order.month} sales={order.sales} 
                                    orderCount={order.orderCount} 
                                    productCount={order.productCount} 
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Wrapper>
            <div className='spacer-100' />
        </Layout>
    )
}

export default SalesManager

const Wrapper = styled.div`
    width: 960px;
    margin: 0 auto;
`